import React from 'react';
import { Paper, Box, Button } from '@mui/material';
import Michaela from '../../../assets/Home/MichaelaGutGelaunt.png';
import { useNavigate } from 'react-router';
import { toStoryIntro } from '../../../utils/routes';
import { useTranslation } from 'react-i18next';
import { ArrowForward } from '@mui/icons-material';

const styles = {
    character: {
        position: "absolute",
        bottom: "3.5rem",
        left: "2rem",
        height: "13rem"
    },
    bubble: {
        position: "absolute",
        top: "10%",
        left: "85%",
        transform: "translate(-85%, -10%)",
        fontSize: "0.7rem",
        lineHeight: "1.2rem",
        width: "45%",
        background: "#fff",
        borderRadius: "1.5rem",
        borderColor: "#aaa",
        borderStyle: "solid",
        padding: "0.5rem",
        textAlign: "center",
        color: "#000"
    },
    choices: {
        position: "absolute",
        bottom: "0px",
        left: "0px"
    },
    choiceButtons: {
        marginBottom: "1rem"
    },
    choicesWrapper: {
        backgroundColor: "secondary.main",
        marginBottom: "1rem",
        maxWidth: "15rem",
        padding: "0.8rem",
        borderRadius: "5px",
        '&:hover': {
            backgroundColor: "secondary.lighter",
            cursor: "pointer"
        },
    },
    button: {
        position: "absolute",
        bottom: "1rem",
        right: "2rem"
    }
};


export default function StoryOnboarding() {

    const {t} = useTranslation()

    const navigate = useNavigate();

    return(
        <Paper 
            sx={{
                padding: 2,
                width: "15rem",
                position: "relative",
                height: "15rem"
            }}
        >
            <img style={{...styles.character}} src={Michaela} alt="character"/>
            {
                <Box sx={{...styles.bubble}}>
                    {t("welcomeComicText1")}
                </Box>
            }
            <Button startIcon=<ArrowForward/> onClick={() => navigate(toStoryIntro)} sx={{...styles.button}} variant="contained" color="secondary">{t("welcomeComicText2")}</Button>
        </Paper>
    )
}